import { Injectable } from '@angular/core';
import { Helper } from './Helper';
import { Router } from '@angular/router';
import { ConnectionService } from 'ng-connection-service';

@Injectable({
  providedIn: 'root'
})
export class CommonApisService {

  constructor(public Helper: Helper,
    public router: Router, public connectionService: ConnectionService) {
    this.connectionService.monitor().subscribe(isConnected => {

      if (isConnected) {

        this.syncInspectionWithServer();
      }


    })
    this.refreshTokenAt(1000 * 60 * 200)
  }
  syncInspectionWithServer() {
    let offline_inspection_reports = this.Helper.get("offline_inspection_reports") || {};
    if (offline_inspection_reports) {
      for (let reps in offline_inspection_reports) {
        offline_inspection_reports[reps]
        this.Helper.makeRequest("admin/completeInspection/" + reps, offline_inspection_reports[reps], "post").subscribe(d => {
          //alert("here");


          let offline_inspection_reports = this.Helper.get("offline_inspection_reports") || {};
          delete offline_inspection_reports[reps]

          this.Helper.set("offline_inspection_reports", offline_inspection_reports);
          let offline_inspections = this.Helper.get("offline_inspections");

          if (offline_inspections[offline_inspection_reports[reps].id]) {
            delete offline_inspections[offline_inspection_reports[reps].id];
            this.Helper.set("offline_inspections", offline_inspections);
          }

        }, (err) => {
          console.log(err.error);



        })
      }
    }

  }




  addFinalFeedback(final_feedback = null, cb, service_type?) {
    this.Helper.makeRequest("institute/confirmation", { final_feedback: final_feedback, service_type }, "post", { toast: false }).subscribe(data => {
      cb(data);
    })
  }

  stepCompleted(step, force = 0, cb = null) {
    this.Helper.makeRequest("assessor/step-completed/" + step + "/" + force, {}, "get", { toast: false }).subscribe(data => {
      if (cb)
        cb(data);
    })
  }

  stepCompletedInstitute(step, force = 0, cb = null) {
    this.Helper.makeRequest("institute/step-completed/" + step + "/" + force, {}, "get", { toast: false }).subscribe(data => {
      if (cb)
        cb(data);
    })
  }

  refreshToken() {
    let token = this.Helper.get("token");
    if (token) {
      this.Helper.makeRequest("auth/refresh", {}, "get", { toast: false, hideLoader: true }).subscribe(data => {

        this.Helper.set("token", data.access_token);

        //
      }, err => {


      })


    }
    else {

    }
  }

  refreshTokenAt(sec) {
    setInterval(() => {
      this.refreshToken()
    }, sec)
  }

  logout(path = "") {

    this.Helper.showAlert((st) => {
      if (st) {

        this.Helper.makeRequest("auth/logout", {}, "get", { toast: false }).subscribe((data) => {

          this.Helper.set("token", null);
          this.Helper.set("user", null);
          this.Helper.user.emit({ completeChange: 1 })
          this.router.navigate([path]);


        }, (err) => {
          this.Helper.set("token", null);
          this.Helper.set("user", null);
          this.Helper.user.emit({ completeChange: 1 })
          this.router.navigate([path]);
        }).catchError(err => {
          this.Helper.set("token", null);
          this.Helper.set("user", null);
          this.Helper.user.emit({ completeChange: 1 })
          this.router.navigate([path]);
        });

      }
    })

  }
  logoutnoc(path = "") {

    this.Helper.showAlert((st) => {
      if (st) {

        this.Helper.makeRequest("noc/logout", {}, "get", { toast: false }).subscribe((data) => {

          this.Helper.set("token", null);
          this.Helper.set("user", null);

          this.router.navigate([path]);


        }).catchError(err => {
          this.Helper.set("token", null);
          this.Helper.set("user", null);
          this.Helper.user.emit({ completeChange: 1 })
          this.router.navigate([path]);
        });

      }
    })

  }


  instituteRefresh(cb?) {
    this.Helper.makeRequest("institute/me", {}, "get", { toast: false }).subscribe((data) => {

      this.Helper.set("user", data.data);
      if (cb) {
        cb(data.data);
      }

    });
  }
  trainerRefresh(cb?) {
    this.Helper.makeRequest("assessor/me", {}, "get", { toast: false }).subscribe((data) => {

      this.Helper.set("user", data.data);
      if (cb) {
        cb(data.data);
      }

    });
  }







}
